import React from 'react'
import styled from 'styled-components'
import { line, radius, font, surface } from 'features/dashboard/tokens'
import { scoreColour } from 'features/dashboard/charts/scoreColour'

const pct = v => (v === null || v === undefined ? 'No score' : `${Math.round(v)}%`)

// rows: [{ key, name, score, sub?, colour?, onClick? }]
const ScoreList = ({ rows = [], emptyLabel = 'Nothing to show yet.' }) => {
  const list = (rows || []).filter(Boolean)
  if (!list.length) return <Empty>{emptyLabel}</Empty>

  return (
    <List>
      {list.map(r => {
        const tint = r.colour || scoreColour(r.score)
        return (
          <Row
            key={r.key}
            $clickable={!!r.onClick}
            onClick={r.onClick || undefined}
            title={r.onClick ? `Open ${r.name}` : undefined}
          >
            <Main>
              <Name>{r.name}</Name>
              {r.sub ? <Sub>{r.sub}</Sub> : null}
              <Bar>
                <BarFill style={{ width: `${Math.max(2, r.score ?? 0)}%`, background: scoreColour(r.score) }} />
              </Bar>
            </Main>
            <Score $tint={scoreColour(r.score)}>{pct(r.score)}</Score>
          </Row>
        )
      })}
    </List>
  )
}

export default ScoreList

const List = styled.div`
  display: flex; flex-direction: column;
`

const Row = styled.div`
  display: flex; align-items: center; gap: 12px;
  padding: 9px 4px;
  border-bottom: 1px solid ${surface.wash};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  &:hover { background: ${({ $clickable }) => ($clickable ? surface.wash : 'transparent')}; }
  &:last-child { border-bottom: none; }
`

const Main = styled.div`
  flex: 1; min-width: 0;
  display: flex; flex-direction: column; gap: 4px;
`

const Name = styled.span`
  font-size: ${font.body};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.haiti};
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
`

const Sub = styled.span`
  font-size: ${font.caption};
  color: ${({ theme }) => theme.colors.grey[800]};
`

const Bar = styled.div`
  height: 6px;
  background: ${({ theme }) => theme.colors.lighterGrey};
  border-radius: ${radius.pill};
  overflow: hidden;
`

const BarFill = styled.div` height: 100%; border-radius: ${radius.pill}; `

const Score = styled.span`
  flex: 0 0 auto;
  font-family: 'FuturaPT-Light', system-ui, sans-serif;
  font-size: 18px;
  color: ${({ $tint }) => $tint};
  font-variant-numeric: tabular-nums;
`

const Empty = styled.div`
  padding: 24px; text-align: center;
  color: ${({ theme }) => theme.colors.grey[800]};
  font-size: ${font.body};
  background: ${({ theme }) => theme.colors.lighterGrey};
  border: 1px dashed ${line.base};
  border-radius: ${radius.md};
`
